import { render } from "./EditPeppol.vue?vue&type=template&id=b337d468&scoped=true"
import script from "./EditPeppol.vue?vue&type=script&lang=js"
export * from "./EditPeppol.vue?vue&type=script&lang=js"

import "./EditPeppol.vue?vue&type=style&index=0&id=b337d468&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b337d468"]])

export default __exports__